<template>
  <div
    ref="spinner"
    class="hollow-dots-spinner"
    :class="{ 'is-masked': isMasked, 'is-active': isActive }"
  >
    <div class="hollow-dots-spinner__overlay" :style="spinnerStyle">
      <div
        v-for="(ds, index) in dotsStyles"
        :key="index"
        class="dot"
        :style="ds"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HollowDotsSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000,
    },
    dotSize: {
      type: Number,
      default: 15,
    },
    dotsNum: {
      type: Number,
      default: 3,
    },
    color: {
      type: String,
      default: '#fff',
    },
    isMasked: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    horizontalMargin() {
      return this.dotSize / 2;
    },

    spinnerStyle() {
      return {
        height: `${this.dotSize}px`,
        width: `${(this.dotSize + this.horizontalMargin * 2) * this.dotsNum}px`,
      };
    },

    dotStyle() {
      return {
        animationDuration: `${this.animationDuration}ms`,
        width: `${this.dotSize}px`,
        height: `${this.dotSize}px`,
        margin: `0 ${this.horizontalMargin}px`,
        borderWidth: `${this.dotSize / 5}px`,
        borderColor: this.color,
        backgroundColor: this.filled ? this.color : 'transparent',
      };
    },

    dotsStyles() {
      const dotsStyles = [];
      const delayModifier = 0.3;
      const basicDelay = 1000;

      for (let i = 1; i <= this.dotsNum; i += 1) {
        const style = Object.assign(
          {
            animationDelay: `${basicDelay * i * delayModifier}ms`,
          },
          this.dotStyle,
        );

        dotsStyles.push(style);
      }

      return dotsStyles;
    },
  },
};
</script>
<style lang="scss">
.hollow-dots-spinner {
  opacity: 0;
  transition: opacity 250ms ease;
  pointer-events: none;

  &__overlay {
    height: 15px;
    width: 100%;
  }

  &.is-masked {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
  }

  &.is-active {
    opacity: 1;
  }

  .dot {
    width: 15px;
    height: 15px;
    margin: 0 calc(15px / 2);
    border: calc(15px / 5) solid #ff1d5e;
    border-radius: 50%;
    float: left;
    transform: scale(0);
    animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;

    &:nth-child(1) {
      animation-delay: calc(300ms * 1);
    }

    &:nth-child(2) {
      animation-delay: calc(300ms * 2);
    }

    &:nth-child(3) {
      animation-delay: calc(300ms * 3);
    }
  }
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
